import React from 'react';
import { Button, Modal } from '@insurancemenu/imenu-components-lib';
import FormSpinner from 'components/common/loaders/FormSpinner';
import { iconLayout, ModalType } from 'global/utils/ModalsHelper';
import { createStyles } from './styles';
import { FORM_MODAL_CLOSE_BTN_TEST_ID, FORM_MODAL_SUBMIT_BTN_TEST_ID } from '../constants';

interface FormModalProps {
  id?: string;
  show: boolean;
  title: string | JSX.Element;
  subtitle?: string | JSX.Element;
  formContent: JSX.Element;
  submitButtonText?: string;
  closeButtonText?: string;
  showCloseButton?: boolean;
  submitButton?: JSX.Element;
  onClose: () => void;
  onSubmit?: () => void;
  modalType?: ModalType;
  icon?: JSX.Element;
  loading?: boolean;
  isFormValid?: boolean;
  'data-test-id'?: string;
}

const FormModal = ({
  show,
  id,
  title,
  subtitle,
  formContent,
  submitButtonText,
  submitButton,
  closeButtonText,
  showCloseButton = true,
  onClose,
  onSubmit,
  icon,
  modalType = ModalType.NO_ICON,
  loading = false,
  isFormValid = true,
  ...rest
}: FormModalProps): JSX.Element => {
  const classes = createStyles();

  const onFormSubmit = (e: React.FormEvent): void => {
    e.preventDefault();
    if (onSubmit) onSubmit();
  };

  return (
    <Modal show={show} onClose={onClose} className={classes.modal} closable id={id} {...rest}>
      {icon || iconLayout(modalType, classes.icon)}
      <p className={classes.modalTitle}>{title}</p>
      {subtitle && <div className={classes.contentText}>{subtitle}</div>}
      <form onSubmit={onFormSubmit} className={classes.form}>
        <div className={classes.formContent}>{formContent}</div>
        <footer className={classes.modalFooter}>
          {showCloseButton && (
            <Button type="outlined" onClick={onClose} size="large" data-test-id={FORM_MODAL_CLOSE_BTN_TEST_ID}>
              {closeButtonText || 'Close'}
            </Button>
          )}
          {submitButton || (
            <Button
              className={classes.actionButton}
              color="primary"
              onClick={onFormSubmit}
              size="large"
              disabled={loading || !isFormValid}
              data-test-id={FORM_MODAL_SUBMIT_BTN_TEST_ID}
            >
              {submitButtonText || 'Save'}
            </Button>
          )}
        </footer>
      </form>

      <FormSpinner display={loading} />
    </Modal>
  );
};

export default FormModal;
